// fvmbags theme — base behaviour
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.classList.toggle('open');
    }
  });

  /* ---------- Tabs (catalog sections) ---------- */
    document.querySelectorAll('[data-tabs]').forEach(function (group) {
      var scope = group.parentElement || group;
    var buttons = group.querySelectorAll('[data-tab-btn]');
    var panels = scope.querySelectorAll('[data-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');
        buttons.forEach(function (b) { b.classList.toggle('active', b === btn); });
        panels.forEach(function (p) {
          p.classList.toggle('active', p.getAttribute('data-tab-panel') === target);
        });
      });
    });
  });

  /* ---------- Countdown timers ---------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  document.querySelectorAll('[data-countdown]').forEach(function (box) {
    var target = new Date(box.getAttribute('data-countdown'));
    if (isNaN(target.getTime())) return;
    var d = box.querySelector('[data-cd-d]');
    var h = box.querySelector('[data-cd-h]');
    var m = box.querySelector('[data-cd-m]');
    var s = box.querySelector('[data-cd-s]');
    function tick() {
      var diff = target - new Date();
      if (diff < 0) diff = 0;
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor(diff / 3600000) % 24;
      var mins = Math.floor(diff / 60000) % 60;
      var secs = Math.floor(diff / 1000) % 60;
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn || btn.disabled) return;
    var wrap = btn.closest('[data-qty-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var step = parseInt(input.step || '1', 10) || 1;
    var min = input.min === '' ? 1 : parseInt(input.min, 10);
    var val = parseInt(input.value || '1', 10) || 1;
    if (btn.getAttribute('data-qty-btn') === 'plus') {
      val += step;
    } else {
      val = Math.max(min, val - step);
    }
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var variantsJson = root.querySelector('[data-variants-json]');
    if (!variantsJson) return;
    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (err) {
      return;
    }

    var optionInputs = root.querySelectorAll('[data-option-input]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var buyBtn = root.querySelector('[data-buy-now]');
    var stockMsg = root.querySelector('[data-stock-msg]');
    var variantIdInput = root.querySelector('[data-variant-id]');
    var gallery = root.parentElement ? root.parentElement.querySelector('[data-gallery]') : null;
    var prices = JSON.parse(root.querySelector('[data-variant-prices]').textContent);
    var colorGroup = root.querySelector('[data-option-values][data-option-name="Color" i]');
    var firstColor = colorGroup && colorGroup.querySelector('[data-option-pill]');
    var colorIndex = firstColor ? Number(firstColor.dataset.optionIndex) : null;
    function normalizeColor(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }
    var knownColors = colorGroup ? Array.from(colorGroup.querySelectorAll('[data-option-pill]'), function(p) {
      return normalizeColor(p.dataset.optionValue);
    }) : [];
    function filterGallery(selection) {
      if (!gallery || colorIndex === null) return;
      var selectedColor = normalizeColor(selection[colorIndex]);
      var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      var matching = thumbs.filter(function(t) {
        return normalizeColor(t.dataset.mediaColor) === selectedColor;
      });
      if (!matching.length) return;
      thumbs.forEach(function(t) {
        var color = normalizeColor(t.dataset.mediaColor);
        var visible = color === selectedColor || !knownColors.includes(color);
        t.classList.toggle('color-hidden', !visible);
        t.hidden = !visible;
        t.classList.remove('active');
        t.setAttribute('aria-pressed', 'false');
      });
      var first = matching[0];
      first.classList.add('active');
      first.setAttribute('aria-pressed', 'true');
      var main = gallery.querySelector('[data-gallery-main-img]');
      if (main) {
        main.src = first.dataset.fullSrc;
        main.alt = first.querySelector('img').alt;
      }
    }

    function currentSelection() {
      var selected = [];
      optionInputs.forEach(function (input) {
        if (input.type === 'radio') {
          if (input.checked) selected[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
        } else {
          selected[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
        }
      });
      return selected;
    }

    function findVariant() {
      var selection = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    function updateOptionAvailability(variant) {
      root.querySelectorAll('[data-option-pill]').forEach(function (pill) {
        var idx = parseInt(pill.getAttribute('data-option-index'), 10);
        var val = pill.getAttribute('data-option-value');
        var selection = currentSelection();
        var testSelection = selection.slice();
        testSelection[idx] = val;
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === testSelection[i]; });
        });
        pill.classList.toggle('unavailable', !match || !match.available);
      });
    }

    function refresh() {
      var variant = findVariant();
      updateOptionAvailability(variant); filterGallery(currentSelection());

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable-text') || 'No disponible'; }
        if (buyBtn) buyBtn.style.display = 'none';
        if (stockMsg) stockMsg.textContent = '';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceNow) priceNow.textContent = prices[String(variant.id)].price;
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = prices[String(variant.id)].compare;
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }

      if (variant.available) {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-add-text') || 'Agregar al carrito'; }
        if (buyBtn) buyBtn.style.display = '';
        if (stockMsg) {
          if (variant.inventory_management && typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
            stockMsg.textContent = '¡Solo quedan ' + variant.inventory_quantity + ' disponibles!';
          } else {
            stockMsg.textContent = '';
          }
        }
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-sold-out-text') || 'Agotado'; }
        if (buyBtn) buyBtn.style.display = 'none';
        if (stockMsg) stockMsg.textContent = 'Agotado temporalmente';
      }


    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', refresh);
    });

    root.querySelectorAll('[data-option-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var input = pill.querySelector('input');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var group = pill.closest('[data-option-values]');
        if (group) group.querySelectorAll('[data-option-pill]').forEach(function (p) { p.classList.remove('selected'); });
        pill.classList.add('selected');
      });
    });

    refresh();
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main-img]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.hidden) return;
        if (mainImg) { mainImg.src = thumb.getAttribute('data-full-src'); mainImg.alt = thumb.querySelector('img').alt; }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });
})();
